import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useToast } from "../components/ToastContext";
import 'react-toastify/dist/ReactToastify.css';
import {api}from '../services/api';
import Layout from "../layout/layout";

const AddNewProject = () => {
  const theme = useTheme();
  const toast = useToast();
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [cloudProviders, setCloudProviders] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
   const userId = sessionStorage.getItem('userId');

const organizationId =sessionStorage.getItem('organizationId');
  const [formData, setFormData] = useState({
    projectName: '',
    cloudSubscriptionId: '',
    cloudProvider: '',
    clientId: '',
// organizationId:'',
    tenantId: '',
    awsAccountId: '',
    userId: sessionStorage.getItem('userId'),
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await api.get(`/Client/GetOrganizationDetailsByUserId/${userId}`);
        setClients(response.data);
      } catch (error) {
        console.error("Error fetching client details:", error);
      }
    };

    const fetchCloudProviders = async () => {
      try {
        const response = await api.get('/Client/cloudProviders');
        setCloudProviders(response.data);
      } catch (error) {
        console.error("Error fetching cloud providers:", error);
      }
    };

    fetchClients();
    fetchCloudProviders();
  }, []);

  const handleSubmit = async () => {
    if (!formData.projectName) {
      toast.error("Project Name is required.");
      return;
    }

    if (!formData.cloudProvider) {
      toast.error("Cloud Provider is required.");
      return;
    }

    if (!formData.organizationId) {
      toast.error("Organization is required.");
      return;
    }

    const projectData = {
      projectName: formData.projectName,
      cloudSubscriptionId: formData.cloudSubscriptionId,
      cloudProvider: formData.cloudProvider,
      // clientId: formData.clientId,
      organizationId:formData.organizationId,
      tenantId: formData.tenantId,
      accountId: formData.awsAccountId,
      userId: formData.userId,
    };

    try {
      setLoading(true);
      const response = await api.post('/Project/addProject', projectData, {
        headers: {
          'X-CORRELATION-ID': 'a4464b6c-0f7c-470e-a41d-b9f6cdf22563',
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        toast.success("Tenant added successfully!");
        navigate('/provider');
      }
    } catch (error) {
      console.error("Error adding Tenant:", error);
      toast.error("Failed to add Tenant.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSubscriptions = async () => {
      if (formData.tenantId) {
        try {
          const response = await api.get(`/Project/getsubscriptions/${formData.tenantId}`);
          setSubscriptions(response.data);
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      }
    };

    fetchSubscriptions();
  }, [formData.tenantId]);

  return (
    <Layout pageType='sideBar'>
      <Box sx={{ flex: 1, pl: theme.spacing(2), color: theme.palette.text.primary }}>
        <Divider />
        <Grid item xs={12} md={6} sx={{ width: '100%' }}>
          <Paper sx={{ p: theme.spacing(3), bgcolor: theme.palette.background.paper, height: '100%', mt: theme.spacing(2) }}>
            <Box sx={{ borderBottom: `2px solid ${theme.palette.primary.main}`, px: theme.spacing(2), display: 'inline-block', mb: theme.spacing(2) }}>
              <Typography variant="body2" gutterBottom sx={{ display: 'inline-block', color: theme.palette.text.primary }}>
                {/* Add Tenant */}
                Add Provider
              </Typography>
            </Box>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="Project Name"
              value={formData.projectName}
              onChange={(e) => setFormData((prevData) => ({ ...prevData, projectName: e.target.value }))}
            
              sx={{ input: { color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize } }}
            />

            <FormControl fullWidth sx={{ mt: theme.spacing(2) }}>
              <InputLabel sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}>Organization</InputLabel>
              <Select
                value={formData.organizationId}
                onChange={(e) => setFormData((prevData) => ({ ...prevData, organizationId: e.target.value }))}
                label="Organization"
                sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}
              >
                <MenuItem value="">-</MenuItem>
                {clients
                  .filter((client) => client.isActive === true)
                  .map((client) => (
                    <MenuItem key={client.organizationId} value={client.organizationId}>
                      {client.organizationName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: theme.spacing(2) }}>
              <InputLabel sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}>Cloud Provider</InputLabel>
              <Select
                value={formData.cloudProvider}
                onChange={(e) => setFormData((prevData) => ({ ...prevData, cloudProvider: e.target.value }))}
                label="Cloud Provider"
                sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}
              >
                <MenuItem value="">-</MenuItem>
                {cloudProviders.map((provider) => (
                  <MenuItem key={provider.value} value={provider.value}>
                    {provider.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {formData.cloudProvider === '1' && (
              <>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Tenant ID"
                  value={formData.tenantId}
                  onChange={(e) => setFormData((prevData) => ({ ...prevData, tenantId: e.target.value }))}
                  sx={{ input: { color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }, mt: theme.spacing(2) }}
                />
              </>
            )}
            {formData.cloudProvider === '2' && (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Account ID"
                value={formData.awsAccountId}
                onChange={(e) => setFormData((prevData) => ({ ...prevData, awsAccountId: e.target.value }))}
                sx={{ input: { color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }, mt: theme.spacing(2) }}
              />
            )}

            <Box sx={{ display: 'flex', mt: theme.spacing(2), justifyContent: 'space-between' }}>
               <Button variant="cancelContained" 
// sx={{
//   borderColor: theme.palette.primary.main,
//   '&:hover': {
//     borderColor: '#17a2fb',
//   },
// }}             
 onClick={() => navigate('/provider')}>
                Cancel
              </Button>
              <Button variant="greenContained" 
// sx={{
//   backgroundColor: theme.palette.customColors.green,
//   '&:hover': {
//     backgroundColor: '#43a047',
//   },
//               }}              
              onClick={() => handleSubmit()}>
                Save
              </Button>
             
            </Box>
          </Paper>
        </Grid>
      </Box>
     
    </Layout>
  );
}

export default AddNewProject;
